import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/signup")({
  component: SignUpPage,
  staticData: {
    title: "Sign Up",
  },
});

function SignUpPage() {
  return (
    <div className="mt-5 flex w-full flex-col items-center gap-4 text-center">
      <p className="text-sm text-muted-foreground">
        Trader Sage is no longer accepting new sign-ups. Existing accounts are
        not affected.
      </p>
      <div className="text-sm">
        {"Already have an account? "}
        <Link to="/signin" className="text-primary hover:text-primary/80">
          Sign in here
        </Link>
      </div>
    </div>
  );
}
